module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/apisauce/~/axios/index.js
// module id = 930
// module chunks = 14